import React from 'react';
import { Checkbox } from 'src/components/widgets/checkbox';
import { PropertiesPanelProperty, PropertiesPanelPropertyContent } from './propertiesPanelProperty';
import { useIsSceneLook } from './propertiesPanelLook';
import { PropertiesPanelSwitchProperty } from './propertiesPanelSwitchProperty';

export type PropertiesPanelCheckboxPropertyProps = {
    id: string;
    label: React.ReactNode;
    checked: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
};

// NELL'INSPECTOR DELLA SCENA UN SÌ/NO È UN INTERRUTTORE (round 4, pacchetto D; utente, 2026-10-14):
// nome a sinistra, switch in fondo alla riga, come le luci e l'AR. Le opzioni dei materiali erano
// spunte con il nome accanto, cioè due forme per la stessa cosa nella stessa colonna. Le
// configurazioni restano `checkbox`: cambia come si disegnano qui, non che cosa dicono.
export const PropertiesPanelCheckboxProperty: React.FC<PropertiesPanelCheckboxPropertyProps> = ({ id, label, checked, onChange, disabled }) => {
    const scene = useIsSceneLook();

    if (scene) return <PropertiesPanelSwitchProperty id={id} label={label} checked={checked} onChange={onChange} disabled={disabled} />;

    return (
        <PropertiesPanelProperty>
            <PropertiesPanelPropertyContent>
                <Checkbox
                    disabled={disabled}
                    checked={checked}
                    label={label}
                    onChange={(checked) => {
                        onChange?.(checked);
                    }}
                />
            </PropertiesPanelPropertyContent>
        </PropertiesPanelProperty>
    );
};
